// Use fixed locale so that SSR and client has same value
// Without stable sorting React.hydrate will change text contents but not value attributes of <option> tags
import { ACTIVE_SERVER_ID } from "@/mk/settings";

export const locale = ACTIVE_SERVER_ID === 201 ? "sk" : ACTIVE_SERVER_ID === 202 ? "cs" : "sk";

export function localeCompare(a: string, b: string): number {
    return a.localeCompare(b, locale, { numeric: true });
}
